import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ModalPopup extends ThemeComponent {

    @Ref() box!: HTMLDivElement;
    @Ref() content!: HTMLDivElement;
    @Ref() close!: HTMLDivElement;

    private modalTriggers: NodeListOf<HTMLElement> = document.querySelectorAll('[data-modal]');

    init() {

        if (this.modalTriggers) {
            for (const trigger of this.modalTriggers) {
                trigger.addEventListener('click', () => {
                    const markup = trigger.getAttribute('data-modal');
                    if (markup) {
                        //
                        const contentContainer = this.content.querySelector('.modal-popup__content-wrapper');
                        contentContainer?.remove();
                        const newContainer = document.createElement('div');
                        newContainer.classList.add('modal-popup__content-wrapper');
                        newContainer.innerHTML = markup;
                        this.content.appendChild(newContainer);
                        this.classList.add('modal-popup--active');
                    }
                });
            }
        }
        this.$listen(this.close, 'click', () => {
            this.classList.remove('modal-popup--active');
        });
    }
}
